import { useCallback } from 'react';

import { WarehouseEntityType } from '@/__generated__/graphql';
import { useFilterContext } from '@/context/FilterProvider';
import { useSearchFacets } from '@/context/SearchFacetsProvider';
import { toTitleCase } from '@/util/string';
import { BaseFilterToggle } from './BaseFilterToggle';
import { ClearSelectAllButton } from './ClearSelectAllButton';
import { FilterSection, FilterSectionProps } from './FilterSection';

const WAREHOUSE_ASSET_TYPE_OPTIONS = [
  {
    label: 'Table',
    value: WarehouseEntityType.Table,
  },
  {
    label: 'View',
    value: WarehouseEntityType.View,
  },
];

interface WarehouseTypeFiltersProps extends FilterSectionProps {}

export const WarehouseTypeFilters: React.FC<WarehouseTypeFiltersProps> = ({
  title = 'Warehouse asset type',
}) => {
  const filterCtx = useFilterContext();
  const { aggregations } = useSearchFacets();
  const selectedWarehouseTypes = filterCtx.filters?.warehouseAssetTypes;
  const handleToggle = useCallback(
    (field: WarehouseEntityType) => {
      const isAdding = !selectedWarehouseTypes?.includes(field);
      filterCtx.updateFilters({ warehouseAssetTypes: [field] }, isAdding);
    },
    [filterCtx, selectedWarehouseTypes],
  );
  return (
    <FilterSection title={title} enableExpansion isDefaultExpanded>
      <ul className="mt-2">
        {WAREHOUSE_ASSET_TYPE_OPTIONS.map((option) => (
          <li key={option.value}>
            <BaseFilterToggle
              isChecked={selectedWarehouseTypes?.includes(option.value)}
              onToggle={() => {
                handleToggle(option.value);
              }}
              count={aggregations?.warehouseAssetTypes?.[option.value]}
            >
              {toTitleCase(option.label)}
            </BaseFilterToggle>
          </li>
        ))}
      </ul>
      <ClearSelectAllButton
        type="warehouseAssetTypes"
        selectedList={selectedWarehouseTypes}
        selectionList={WAREHOUSE_ASSET_TYPE_OPTIONS}
      />
    </FilterSection>
  );
};
